<template>
    <v-list class="transparent">
        <v-list-item class="pa-0" dense style="min-height:25px" v-for="(propertyName, i) in displayKeys" :key="i">

                <v-list-item-title>{{ propertyName }}</v-list-item-title>

                <v-list-item-subtitle class="text-right">
                    {{ jsonData[propertyName] }}
                </v-list-item-subtitle>

        </v-list-item>
    </v-list>
</template>

<script>
export default {
    props: {
        jsonData : {
            type : Object,
            default : () => {},
        },

        exclude : {
            type: Array[String],
            default : () => [],
        }
    },

    computed: {

    displayKeys() {

        let keys = []

        if(!this.jsonData)
            return keys;

        Object.keys(this.jsonData).forEach(key => {
            if(!this.exclude.includes(key))
                keys.push(key);
        })

        return keys
    }
  }
}
</script>

<style>

</style>